import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {
  InputElementMetaData,
  ModalComponent,
  SpinnerComponent
} from 'remarketing-ui-components-lib';
import {InspectionReportDto, VehicleInformation, DateUtilsService, NewPostingInspectionOption} from 'remarketing-angular-library';
import { TranslocoDirective } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-new-posting-modal',
    templateUrl: './new-posting-modal.component.html',
    styleUrls: ['./new-posting-modal.component.scss'],
    imports: [TranslocoDirective, ModalComponent, SpinnerComponent, CommonModule]
})
export class NewPostingModalComponent {
  @ViewChild(ModalComponent) modal: ModalComponent;
  @Input() decodedDetails?: VehicleInformation;
  @Input() existingInspectionReport?: InspectionReportDto;
  @Input() isLoading;
  @Input() vin: string;
  @Input() errorHeaderKey?: string;
  @Input() errorMessageKey?: string;
  @Input() availableInspectionActions?: InputElementMetaData[];
  @Input() inspectionFetched = false;
  @Input() thirdPartyPostingRequest?: boolean;
  @Output() modalClosed = new EventEmitter<void>();
  @Output() getInspections = new EventEmitter<void>();
  @Output() getChromeOptions = new EventEmitter<NewPostingInspectionOption>();

  get initialPostingStageReady(): boolean {
    return !this.isLoading && !this.thirdPartyPostingRequest && !this.inspectionFetched;
  }

  /**
   * Boolean representing if the call to retrieve an inspection has been made, but prior to the call to retrieve Chrome data.
   */
  get inspectionStageReady(): boolean {
    return !this.isLoading && !this.thirdPartyPostingRequest && this.inspectionFetched;
  }

  /**
   * Boolean representing if any network calls at any stage received error responses.
   */
  get errorResponse(): boolean {
    return !!this.errorHeaderKey && !!this.errorMessageKey;
  }

  constructor(private readonly dateUtilsService: DateUtilsService) {}

  show() {
    this.modal.show();
  }

  close() {
    this.modal.close();
    this.modalClosed.emit();
  }

  /**
   * When the decoded VIN looks good to the user, proceed to call VIW to get inspections.
   */
  continueWithDecodedVin() {
    this.getInspections.emit();
  }

  /**
   * Based on the selected option, we will need to use the existing inspection to call chrome.
   */
  continueWithChromeCall() {
    const inspectionOptionSelected = this.availableInspectionActions.find(action => action.isChecked === true).id;
    this.getChromeOptions.emit(NewPostingInspectionOption[inspectionOptionSelected]);
  }

  toggleInspectionSelection(inspectionActionType: string) {
    this.availableInspectionActions.forEach(action => (action.isChecked = action.name === inspectionActionType));
  }

  localizeDate(date) {
    return this.dateUtilsService.localizeDate(date);
  }
}
